// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import PanelMenuDefaultProps from "@insite/mobius/PanelMenu/presentationProps";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { fontConfig } from "@vanmeter/XDL/constants";
import ChevronLeft from "@vanmeter/XDL/Icons/IconAngleLeftLarge";
import ChevronRight from "@vanmeter/XDL/Icons/IconAngleRightSmall";
import { xBaseTheme } from "@vanmeter/XDL/types";
import { color, getSystemColor } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...PanelMenuDefaultProps,
        bodyColor: "common.ui1",
        headerColor: "common.ui1",
        cssOverrides: {
            menu: css`
                padding: 0 0 16px 0;
            `,
            children: css`
                background-color: ${getSystemColor("common.ui1")};
                z-index: 1;
            `,
        },
        childTypographyProps: {
            ...fontConfig.smallSingleLine,
            weight: fontConfig.weight.regular,
            color: "text",
            css: css`
                display: block;
                word-wrap: break-word;
                text-align: left;
            `,
        },
        backIconProps: {
            src: ChevronLeft,
            width: 7,
            height: 14,
            css: css`
                &&& {
                    color: ${color("common.ui5")};
                }
            `,
        },
        panelRowProps: {
            color: "common.ui1",
            moreIconProps: {
                src: ChevronRight,
                size: 7,
                height: 18,
                color: "common.ui5",
                css: css`
                    // expands touch/click area
                    padding: 16px;
                    margin: -16px;
                    width: auto;
                `,
            },
            css: css`
                padding: 10px 16px;
                width: 100%;

                ${({ header }: any) =>
                    header
                        ? css`
                              margin-top: 8px;

                              button {
                                  font-size: ${fontConfig.smallSingleLine.size}px;
                                  line-height: ${fontConfig.smallSingleLine.lineHeight};
                                  font-weight: ${fontConfig.weight.regular};
                                  color: ${getSystemColor("text")};
                                  display: flex;
                                  align-items: baseline;
                                  gap: 12px;
                              }
                          `
                        : css`
                              &:hover,
                              &:focus {
                                  background-color: ${getSystemColor("common.ui15")};
                                  ${IconWrapper}, ${TypographyStyle} {
                                      color: ${getSystemColor("common.ui1")};
                                  }
                              }
                          `}

                ${({ isCurrent }: any) =>
                    isCurrent &&
                    css`
                        && {
                            background: ${getSystemColor("common.ui16")};
                            ${IconWrapper}, ${TypographyStyle} {
                                color: ${getSystemColor("common.ui1")};
                            }
                        }
                    `}
            `,
        },
    },
} as xBaseTheme["panelMenu"];
